// Helper to add more readable keypress commands
// onKeyPress('esc', doSomething);
export const onKeyPress = (readableKeyName, callback) => {
    const normalizedKeyName = readableKeyName.toLowerCase();

    document.addEventListener('keydown', (e) => {
        if(normalizedKeyName === 'esc' && e.keyCode == 27) {
            callback();
        }
    });
}
  